import React, { useState } from 'react';
import ReportBugModal from './ReportBugModal';
import './ReportBugButton.css';

function ReportBugButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <button 
        className="report-bug-btn" 
        onClick={openModal}
        aria-label="Report a bug"
        title="Report a bug"
      >
        🐛
      </button>
      
      <ReportBugModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
      />
    </>
  );
}

export default ReportBugButton;
